function withoutLeadingCharacters(string, characters) {
  return string.replace(new RegExp(`^${characters}`), "");
}
export {
  withoutLeadingCharacters as default
};
//# sourceMappingURL=withoutLeadingCharacters.js.map
